// ==============================|| OVERRIDES - DIALOG ||============================== //

export default function Dialog(theme) {
  const isDark = theme?.palette?.mode === 'dark';

  return {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: isDark ? 'rgba(10, 11, 14, 0.55)' : undefined,
          backdropFilter: isDark ? 'blur(4px)' : undefined
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: '12px',
          backgroundColor: isDark ? (theme.palette?.background?.raised || '#272B33') : 'background.paper',
          border: isDark ? '1px solid rgba(255, 255, 255, 0.08)' : 'none',
          boxShadow: isDark 
            ? '0 12px 32px rgba(0, 0, 0, 0.45)' 
            : '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
        }
      }
    }
  };
}
